import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  AllocationViewSupportSMSInitialState,
  AllocationViewSupportSMSCountryCodesLoad,
  AllocationViewSupportedSMSSet,
} from './allocation-view-support-sms.actions';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { AllocationViewSupportSMSService } from './allocation-view-support-sms.service';
import { catchError, map, Observable, of, take, tap } from 'rxjs';
import { CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AllocationViewSupportSMSStateModel {
  coutryCodes: string[];
  isSupportedSMS: boolean;
  loaded: boolean;
}

const initialState: AllocationViewSupportSMSStateModel = {
  coutryCodes: [],
  isSupportedSMS: true,
  loaded: false,
};

@State<AllocationViewSupportSMSStateModel>({
  name: 'allocationViewSupportSMS',
  defaults: initialState,
})
@Injectable()
export class AllocationViewSupportSMSState {
  constructor(
    private allocationViewSupportSMS: AllocationViewSupportSMSService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: AllocationViewSupportSMSStateModel): AllocationViewSupportSMSStateModel {
    return state;
  }

  @Selector()
  static getSupportedCoutries(state: AllocationViewSupportSMSStateModel): string[] {
    return state.coutryCodes;
  }

  @Selector()
  static isSupportedSMS(state: AllocationViewSupportSMSStateModel): boolean {
    return state.isSupportedSMS;
  }

  @Selector()
  static getLoaded(state: AllocationViewSupportSMSStateModel): boolean {
    return state.loaded;
  }

  @Action(AllocationViewSupportSMSCountryCodesLoad)
  getSupportedCountryCodes(
    ctx: StateContext<AllocationViewSupportSMSStateModel>,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewSupportSMS.getSupportedCountryCodes().pipe(
      take(1),
      tap((coutryCodes: string[]) => {
        this.allocationViewSupportSMS.saveCountryCodes(coutryCodes);
      }),
      map((coutryCodes: string[]) => {
        ctx.patchState({ coutryCodes, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewSupportedSMSSet)
  setSupportSMS(
    ctx: StateContext<AllocationViewSupportSMSStateModel>,
    { payload }: AllocationViewSupportedSMSSet,
  ): void {
    ctx.patchState({ isSupportedSMS: payload });
  }

  @Action(AllocationViewSupportSMSInitialState)
  setInitialState(ctx: StateContext<AllocationViewSupportSMSStateModel>): void {
    ctx.setState(initialState);
  }
}
